/** @internal */
export const GreaterThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThan");
/** @internal */
export const GreaterThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualTo");
/** @internal */
export const LessThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThan");
/** @internal */
export const LessThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualTo");
/** @internal */
export const IntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Int");
/** @internal */
export const BetweenTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Between");
/** @internal */
export const GreaterThanBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanBigint");
/** @internal */
export const GreaterThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToBigint");
/** @internal */
export const LessThanBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanBigint");
/** @internal */
export const LessThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualToBigint");
/** @internal */
export const BetweenBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/BetweenBigint");
/** @internal */
export const MinLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinLength");
/** @internal */
export const MaxLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxLength");
/** @internal */
export const LengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Length");
/** @internal */
export const MinItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinItems");
/** @internal */
export const MaxItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxItems");
/** @internal */
export const ItemsCountTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ItemsCount");
/** @internal */
export const ParseJsonTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ParseJson");
//# sourceMappingURL=filters.js.map